export default "__VITE_ASSET__c701c7b0__"